
import {
  Box,
  Container,
  Grid,
  Stack,
  Chip,
  Pagination,
} from "@mui/material";

import { NoticiaCard } from "./NoticiaCard";



export const NoticiasPage = ({
  noticias,
  buscar,
  categoria,
  setCategoria,
  page,
  setPage,
  categorias
}) => {

  

 const noticiasFiltradas = noticias.filter((item) => {

    const coincideCategoria =
        categoria === "Todas" ||
        item.tipo === categoria;

    const coincideBusqueda =
        (item.titulo || "")
            .toLowerCase()
            .includes(buscar.toLowerCase()) ||
        (item.descripcion || "")
            .toLowerCase()
            .includes(buscar.toLowerCase());

    return coincideCategoria && coincideBusqueda;
});


    const noticiasPorPagina = 6;

    const totalPaginas = Math.ceil(
        noticiasFiltradas.length / noticiasPorPagina
    );


    const noticiasActuales = noticiasFiltradas.slice(
        (page - 1) * noticiasPorPagina,
        page * noticiasPorPagina
    );

return(

<Box

sx={{

background:"#F8FAFC",

minHeight:"100vh",

pb:12,
pt:5

}}

>
   <Container

maxWidth="lg"

sx={{

mt:8,
display:'flex',
alignItems:'center',
justifyContent:'center',
flexDirection:'column'

}}

>

<Stack

direction={{

xs:"column",

md:"row",

}}

spacing={2}

justifyContent={{sm:"center",md:"space-between"}}

alignItems={{

xs:"center",

md:"center",

}}

sx={{mb:10}}
>

<Box

sx={{

display:"flex",

justifyContent:'center',
alignItems:'center',
flexWrap:"wrap",

gap:{xs:1, md:2},

}}

>

 {categorias.map((cat) => (

                            <Chip
                                key={cat.value}
                                label={cat.label}
                                clickable

                                onClick={() => {
                                    setCategoria(cat.value);
                                    setPage(1);
                                }}

                                sx={{
                                    height: 44,
                                    px: 1,
                                    fontWeight: 700,
                                    fontSize: 15,
                                    fontFamily: "Archivo",
                                    borderRadius: "30px",
                                    transition: ".3s",

                                    background:
                                        categoria === cat.value
                                            ? "linear-gradient(135deg,#C62828,#8f1515,#484a75)"
                                            : "#fff",

                                    color:
                                        categoria === cat.value
                                            ? "#fff"
                                            : "#484a75",

                                    border:
                                        categoria === cat.value
                                            ? "none"
                                            : "1px solid #d8dce5",

                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                    },
                                }}
                            />

                        ))}


</Box>


</Stack>

<Grid container spacing={4} sx={{ mt: 2, width:'100%' }}>

  {noticiasActuales.map((item, index) => (

    <Grid
      key={item.id}
      size={{ xs: 12, sm: 6, lg: 4 }}
    >
      <NoticiaCard
        item={item}
        index={index}
      />
    </Grid>

  ))}

</Grid>
<Box sx={{
    mt:7
}}>
    <Pagination
        page={page}
        count={totalPaginas}
        onChange={(e,value)=>setPage(value)}
        color="primary"
        size="large"
    />
</Box>

</Container>

</Box>
)
}